import * as React from "react";
import { TextBox } from "../../forms/informedv2/TextBox";
import { Required } from "../../forms/validation/Required";
import { useReferenceContextProvider } from "../../Core/ReferenceContextProvider";
import { MultiSelect } from "../../forms/informedv2/MultiSelect";

export interface MetricsForm {
    TargetSubjects: number;
    TargetSessions: number;
}

export const StudyMetricsForm = () => {
    return (
        <>
            <div className="row">
                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                    <label htmlFor="Name">Target Subject Count</label>
                    <TextBox<number, MetricsForm>
                        id="TargetSubjects"
                        field="TargetSubjects"
                    />
                </div>
                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                    <label htmlFor="Name">Target Session Count</label>
                    <TextBox<number, MetricsForm>
                        id="TargetSessions"
                        field="TargetSessions"
                    />
                </div>
            </div>
        </>
    );
}
